import { Injectable, Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

// under systemjs, moment is actually exported as the default export, so we account for that
const momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
const browserTimeZone = moment.tz.guess();
export const DEFAULT_DATE_TIME_FORMAT: string = 'MMM DD, YYYY hh:mm:ss A z';
export const NEVER_EXPIRE_DATE: string = '2116-01-01T00:00:00.000Z';

export interface settings {
    format?: string;
    timezone?: string;
}

@Injectable()
export class FormatterService {
    /**
     * @function Wrapper for moment
     * @returns Moment object
     */
    createMoment(value?: any): moment.Moment {
        return momentConstructor(value);
    }

    /**
     * @function formats a string into default or inputted format and timezone
     * @param value: a date value either string or js Date object.
     * We recommend using a string ISO 8601 format.
     * @param settings: an optional settings interface for users to change the date/time format
     * and timezone.
     * @returns string in the specified format and timezone.
     */
    formatDate(value?: any, settings: settings = {}): string {
        let format = settings.format ? settings.format : DEFAULT_DATE_TIME_FORMAT;
        let timezone =  settings.timezone ? settings.timezone : browserTimeZone;
        if(value == undefined && value==null)
        {
            return "";
        }
        else
        {
            return this.createMoment(value).tz(timezone).format(format);
        }
    }

    /**
     * @function Checks if the moment object is past the never Date
     * @param expirationDate: Moment object.  Expects the time to be in UTC
     * @returns boolean
     */
    isNeverExpired(expirationDate: moment.Moment): boolean { //Dec 31, 2115 16:00:00 UTC (moment)
        let localNeverExpiredDate = this.createMoment(NEVER_EXPIRE_DATE).utcOffset(0, true);
        return expirationDate.isSameOrAfter(localNeverExpiredDate);
    }

}

@Pipe({name: 'formatDate'})
export class FormatDatePipe implements PipeTransform {
    constructor(private formatter: FormatterService) {}

    transform(value: string, settings: settings = {}): string {
        return this.formatter.formatDate(value, settings);
    }
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/shared/formatter.service.ts